import {scaleSize, WINDOW_WIDTH, DIMENSIONS} from './mixins';
import * as COLORS from './colors';
import { useState, useEffect } from 'react';

export const LEFT_MARGIN = scaleSize(22)
export const SCALE_WIDTH = DIMENSIONS.width;                // PUT WINDOW WIDTH
export const SCREEN_WIDTH = DIMENSIONS.width/10 * 8;                // PUT WINDOW WIDTH
export const SCALE_1000 = scaleSize(1000);
export const SCALE_800 = scaleSize(800);
export const SCALE_650 = scaleSize(650);
export const SCALE_600 = scaleSize(600);
export const SCALE_500 = scaleSize(500);
export const SCALE_400 = scaleSize(400);
export const SCALE_360 = scaleSize(360);
export const SCALE_350 = scaleSize(350);
export const SCALE_335 = scaleSize(335);
export const SCALE_330 = scaleSize(330);
export const SCALE_300 = scaleSize(300);
export const SCALE_290 = scaleSize(290);
export const SCALE_280 = scaleSize(280);
export const SCALE_260 = scaleSize(260);
export const SCALE_240 = scaleSize(240);
export const SCALE_220 = scaleSize(220);
export const SCALE_210 = scaleSize(210);
export const SCALE_200 = scaleSize(200);
export const SCALE_190 = scaleSize(190);
export const SCALE_180 = scaleSize(180);
export const SCALE_170 = scaleSize(170);
export const SCALE_165 = scaleSize(165);
export const SCALE_160 = scaleSize(160);
export const SCALE_150 = scaleSize(150);
export const SCALE_152 = scaleSize(152);
export const SCALE_142 = scaleSize(142);
export const SCALE_130 = scaleSize(130);
export const SCALE_125 = scaleSize(125);
export const SCALE_120 = scaleSize(120);
export const SCALE_104 = scaleSize(104);
export const SCALE_100 = scaleSize(100);
export const SCALE_96 = scaleSize(96);
export const SCALE_90 = scaleSize(90);
export const SCALE_88 = scaleSize(88);
export const SCALE_82 = scaleSize(82);
export const SCALE_80 = scaleSize(80);
export const SCALE_72 = scaleSize(72);
export const SCALE_64 = scaleSize(64);
export const SCALE_60 = scaleSize(60);
export const SCALE_50 = scaleSize(50);
export const SCALE_48 = scaleSize(48);
export const SCALE_42 = scaleSize(42);
export const SCALE_40 = scaleSize(40);
export const SCALE_38 = scaleSize(38);
export const SCALE_36 = scaleSize(36);
export const SCALE_32 = scaleSize(32);
export const SCALE_28 = scaleSize(28);
export const SCALE_25 = scaleSize(25);
export const SCALE_24 = scaleSize(24);
export const SCALE_22 = scaleSize(22);
export const SCALE_20 = scaleSize(20);
export const SCALE_18 = scaleSize(18);
export const SCALE_16 = scaleSize(16);
export const SCALE_14 = scaleSize(14);
export const SCALE_12 = scaleSize(12);
export const SCALE_10 = scaleSize(10);
export const SCALE_8 = scaleSize(8);
export const SCALE_5 = scaleSize(5);
export const SCALE_4 = scaleSize(4);
export const SCALE_3 = scaleSize(3);


export const ScreenContainer = {
    flex: 1,
    padding: SCALE_16,
    backgroundColor: COLORS.BACKGROUND,
    justifyContent: 'center'
    
};

export const RegisterHeader = {
    flexDirection: 'row',
    justifyContent: 'center'
};

export const container = {
    padding: SCALE_8,
};




